import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Instagram } from "lucide-react";

export default function InstagramFeed() {
  const [sectionRef, visible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      ref={sectionRef}
      data-testid="instagram-feed-section"
      className={`py-16 md:py-24 bg-white animate-fade-up ${visible ? "visible" : ""}`}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4" style={{ background: "rgba(180, 110, 182, 0.08)" }}>
            <Instagram className="w-4 h-4" style={{ color: "#b46eb6" }} />
            <span className="text-sm font-semibold" style={{ color: "#b46eb6" }}>Folge uns</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight" style={{ color: "#1F2937" }}>
            @run.for.rett auf Instagram
          </h2>
          <p className="text-base mt-3 max-w-xl mx-auto" style={{ color: "#4B5563" }}>
            Bleib auf dem Laufenden – Neuigkeiten, Bilder und Updates rund um Run for Rett.
          </p>
          <div className="section-divider mx-auto mt-4" />
        </div>

        <a
          href="https://www.instagram.com/run.for.rett/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-embed-link"
          className="block max-w-md mx-auto rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 border border-gray-100"
        >
          <div className="p-5 flex items-center gap-4 bg-white">
            <div className="w-14 h-14 rounded-full flex items-center justify-center shrink-0" style={{ background: "linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)" }}>
              <Instagram className="w-7 h-7 text-white" />
            </div>
            <div className="text-left">
              <p className="font-heading font-bold text-base" style={{ color: "#1F2937" }}>run.for.rett</p>
              <p className="text-sm" style={{ color: "#9CA3AF" }}>Laufen für eine Zukunft ohne Rett-Syndrom</p>
            </div>
          </div>
          <div className="px-5 pb-5 pt-2 bg-white">
            <div
              className="w-full py-3 rounded-full text-center text-sm font-bold text-white"
              style={{ background: "linear-gradient(90deg, #b46eb6, #7DD4B5)" }}
            >
              Auf Instagram folgen
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}
